module.exports = "voucher: {{transactionDiscount}},\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/Wizard/Snippet/snippets/transactionDiscount.html
// module id = 2157
// module chunks = 0